import { tKey } from 'ember-intl';

export const ACCESS_RIGHTS = {
  ADMIN: 'ADMIN',
  WRITE: 'WRITE',
  READ: 'READ',
} as const;
export type AccessRight = (typeof ACCESS_RIGHTS)[keyof typeof ACCESS_RIGHTS];

export const MIXED = 'MIXED' as const;
export type MixedRole = typeof MIXED;

export const ROLE_OPTIONS_MAP: Record<AccessRight, ReturnType<typeof tKey>> = {
  ADMIN: tKey('settings.users.role.admin'),
  WRITE: tKey('settings.users.role.editor'),
  READ: tKey('settings.users.role.viewer'),
};
